const httpConfig = {

    // BASE_API: 'http://office.hbjpim.cn:8088/',
    // BASE_API: 'http://127.0.0.1:3333/jysite/',
    BASE_API: process.env.NODE_ENV == 'production'?'http://office.hbjpim.cn/jysite/':'http://192.168.0.100:8099/jysite/'
   //BASE_API: 'http://office.hbjpim.cn/jysite/',  //线上地址
}

export default httpConfig



//////////////////
// WEBPACK FOOTER
// ./static/httpConfig.js
// module id = Lei5
// module chunks = 10